function isProgramType(type) {
    return (p) => {
        return p.type === type;
    };
}
export const isContentProgram = isProgramType('content');
export const isFlexProgram = isProgramType('flex');
export const isRedirectProgram = isProgramType('redirect');
export const isCustomProgram = isProgramType('custom');
export const isFillerProgram = isProgramType('filler');
export function programUniqueId(program) {
    if (isContentProgram(program)) {
        return program.uniqueId;
    }
    else if (isFlexProgram(program)) {
        return 'flex'; // Cannot really be unique identified
    }
    else if (isRedirectProgram(program)) {
        return `redirect.${program.channel}`;
    }
    else if (isCustomProgram(program)) {
        return `custom.${program.customShowId}.${program.id}`;
    }
    else if (isFillerProgram(program)) {
        return `filler.${program.fillerListId}.${program.id}`;
    }
    return null;
}
export function isEpisodeWithHierarchy(f) {
    return f.type === 'episode' && !!f.season && (!!f.season?.show || !!f.show);
}
export function isMusicTrackWithHierarchy(f) {
    return f.type === 'track' && !!f.album && (!!f.album?.artist || !!f.artist);
}
export function getChildItemType(typ) {
    switch (typ) {
        case 'show':
            return 'season';
        case 'season':
            return 'episode';
        case 'album':
            return 'track';
        case 'artist':
            return 'album';
        default:
            return 'item';
    }
}
export function isChildItem(typ) {
    switch (typ) {
        case 'season':
        case 'episode':
        case 'album':
        case 'track':
            return true;
        default:
            return false;
    }
}
export function getParentItem(input) {
    switch (input.type) {
        case 'show':
        case 'movie':
        case 'music_video':
        case 'other_video':
        case 'artist':
            return undefined;
        case 'season':
            return input.show;
        case 'episode':
            return input.season;
        case 'album':
            return input.artist;
        case 'track':
            return input.album;
    }
}
export function getParentItemType(typ) {
    switch (typ) {
        case 'season':
            return 'show';
        case 'episode':
            return 'season';
        case 'track':
            return 'album';
        case 'album':
            return 'artist';
        default:
            return undefined; // parent groupings will technically return this as well
    }
}
export function getParentItemUuid(input) {
    switch (input.type) {
        case 'show':
        case 'movie':
        case 'music_video':
        case 'other_video':
        case 'artist':
        case 'folder':
        case 'collection':
        case 'playlist':
            return undefined;
        case 'season':
            return input.show?.uuid;
        case 'episode':
            return input.season?.uuid;
        case 'album':
            return input.artist?.uuid;
        case 'track':
            return input.album?.uuid;
    }
}
export function getChildCount(input) {
    switch (input.type) {
        case 'movie':
        case 'episode':
        case 'track':
        case 'music_video':
        case 'other_video':
            return undefined;
        case 'show':
        case 'season':
        case 'album':
        case 'artist':
        case 'folder':
        case 'collection':
        case 'playlist':
            return input.childCount;
    }
}
export function isTerminalItemType(program) {
    const type = typeof program === 'string' ? program : program.type;
    return (type === 'movie' ||
        type === 'music_video' ||
        type === 'episode' ||
        type === 'track' ||
        type === 'other_video');
}
export function isGroupingItemType(program) {
    const type = typeof program === 'string' ? program : program.type;
    return (type === 'show' ||
        type === 'season' ||
        type === 'artist' ||
        type === 'album');
}
export function isStructuralItemType(program) {
    const type = typeof program === 'string' ? program : program.type;
    return (type === 'folder' ||
        type === 'collection' ||
        type === 'playlist' ||
        type === 'library');
}
//# sourceMappingURL=Program.js.map